import {
  emptyPolicyHolder,
  IAddressInput,
  IPolicyHoldersInput,
  IQuotePriceSummary,
  IValidation,
  QuoteStage,
  QuoteType,
} from '@nibtravel/shared/util/models';

import { IQuoteInput } from './quote-input.model';

export interface IFormState {
  errors?: Record<string, string>;
  dirty?: boolean;
  status?: string;
  name?: string;
}

export interface IQuoteState extends Record<string, unknown> {
  id: string | undefined;
  hasConfigChanged: boolean;
  clientSessionId: string | undefined;
  /**
   * @deprecated should stop using this as it's not a reliable
   * way to track the actual stage of th Quote. Use currentRoute instead
   */
  stage: QuoteStage;
  evaluatedAt: string | undefined;
  input: IQuoteInput;
  prices?: IQuotePriceSummary[];
  donationBands?: number[];
  policyNumber?: string;
  isPurchaseInitiated?: boolean;
  isPurchased?: boolean;
  brandCode?: string;
  customerUserId?: number;
  validation?: IValidation;
  qqcForm?: IFormState;
  detailsForm?: IFormState;
  currentRoute: string;
  paymentCorrelationId?: string;
  analytics?: Record<string, string>;
}

export const emptyQuoteInput = {
  customerInterfaceId: 1,
  quoteType: QuoteType.SingleTrip,
  homeAddress: {
    countryCode: 'AUS',
  },
  destinationCountryCodes: [],
  policyHolders: [emptyPolicyHolder],
  regulatoryDeclarations: [],
  departureDate: '',
  coverEndDate: '',
  campaignCode: '',
  partnerCode: '',
};

export const defaultQuoteState = {
  id: undefined,
  clientSessionId: undefined,
  stage: QuoteStage.Initial,
  currentRoute: '',
  evaluatedAt: undefined,
  input: emptyQuoteInput,
  validation: {
    isValid: false,
  },
  hasConfigChanged: false,
};

export interface ITripSummary {
  policyHolders: IPolicyHoldersInput[];
  destinationCountryCodes: string[];
  departureDate?: string;
  coverEndDate?: string;
  homeAddress?: IAddressInput;
}
